import { Controller } from "@hotwired/stimulus"

// カードの50%以上が1秒以上画面内に表示されたときを「表示」とみなす。
// 描画時点で送ると、画面外(スクロールで届いていない・画面幅によりdisplay:none)のカードも計上されてしまうため
const VISIBLE_RATIO = 0.5
const DWELL_MS = 1000

// 候補者カードの表示(impression)を、GA4での効果測定用にdataLayerへ送る。
// Pick up・言い換えラベルが詳細閲覧・気になるオファーに繋がっているかをBigQuery(GA4エクスポート)で分析するため、
// 表示時点の判定結果(Pick up・ラベルの短縮コード)と表示順位をイベントパラメータに載せる。
// Connects to data-controller="scout--profile-impression"
export default class extends Controller {
  static values = {
    serial: String,
    officeId: Number,
    position: Number, // 未指定(保留/保留解除によるカード差し替え時)はnullで送る
    sortOrder: String,
    recommended: Boolean,
    labelCodes: String,
    labelCount: Number,
    trackImpression: { type: Boolean, default: true },
  }

  connect() {
    if (!this.trackImpressionValue) return
    if (document.documentElement.hasAttribute('data-turbo-preview')) return // キャッシュプレビュー中は表示として数えない

    this.observer = new IntersectionObserver(this.#handleIntersect, { threshold: VISIBLE_RATIO })
    this.observer.observe(this.element)
    document.addEventListener('visibilitychange', this.#restartTimer)
  }

  disconnect() {
    this.#stopObserving()
  }

  #handleIntersect = ([entry]) => {
    this.isIntersecting = entry.isIntersecting
    this.#restartTimer()
  }

  // タブが裏に回っている間は見られていないため計測を止め、戻ったときに画面内であれば計測し直す
  // (IntersectionObserverは交差状態が変わらない限り再通知しないため、visibilitychangeで補う)
  #restartTimer = () => {
    clearTimeout(this.timer)
    if (!this.isIntersecting || document.visibilityState === 'hidden') return

    this.timer = setTimeout(() => {
      this.#pushEvent('scout_profile_card_view')
      this.#stopObserving() // 1回の描画につき1回だけ送る
    }, DWELL_MS)
  }

  #stopObserving() {
    this.observer?.disconnect()
    clearTimeout(this.timer)
    document.removeEventListener('visibilitychange', this.#restartTimer)
  }

  // GTMのデータレイヤーは直前のpushの値を引き継ぐため、全キーを毎回明示的に送る(未指定はnull)
  #pushEvent(eventName) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: eventName,
      profile_serial: this.serialValue,
      office_id: this.officeIdValue,
      list_position: this.hasPositionValue ? this.positionValue : null,
      sort_order: this.sortOrderValue,
      is_recommended: this.recommendedValue ? 1 : 0,
      label_codes: this.labelCodesValue,
      label_count: this.labelCountValue,
    })
  }
}
